import React from 'react';
import SEO from "../common/SEO";
import Layout from "../common/Layout";
import BreadcrumbOne from "../elements/breadcrumb/BreadcrumbOne";
import { FiCheck } from "react-icons/fi";
import SectionTitle from "../elements/sectionTitle/SectionTitle";
import ContactOne from "../elements/contact/ContactOne";
import ScrollAnimation from "react-animate-on-scroll";


const DataCenter = () => {
    return (
        <>
            <SEO title="Services" />
            <Layout>
                <BreadcrumbOne 
                    title="Data Center Solutions"
                    rootUrl="/"
                    parentUrl="Home"
                    currentUrl="Data Center Solutions"
                />
            <div className="main-content">
            
        <div className="rn-splite-style bg-color-blackest">
            <div className="split-wrapper">
                <div className="row no-gutters radius-10 align-items-center">
                    <div className="order-2 order-lg-1 col-lg-12 col-xl-6 col-12">
                        <div className="split-inner">
                            <ScrollAnimation 
                            animateIn="fadeInUp"
                            animateOut="fadeInOut"
                            animateOnce={true}>
                                <h5 className="title">Pushing out limits to provide the highest quality services
                                </h5>
                            </ScrollAnimation>
                            <ScrollAnimation 
                            animateIn="fadeInUp"
                            animateOut="fadeInOut"
                            animateOnce={true}>
                                <p className="description">Our Data Centre architecture that is scalable and adaptable, dramatically reducing time and complexity from concept and design through installation. UPS, power distribution, cooling, racks, security and management software components are conceived and tested as part of an integrated system. Perfect for private clouds, small and large data centres, delivering high availability and real energy savings whether deployed on its own, in a zone, or in incremental steps.</p>
                            </ScrollAnimation>
                        
                        <ScrollAnimation 
                            animateIn="fadeInUp"
                            animateOut="fadeInOut"
                            animateOnce={true}>
                                <p className="description">Solutions that we provide is easy to configure and deploy which will be Adaptable to any changing business needs with high-performance.</p>
                            </ScrollAnimation>
                        </div>
                    </div>
                    <div className="order-1 order-lg-2 col-lg-12 col-xl-6 col-12">
                        <div className="thumbnail">
                            <img src="./images/portfolio/datac.jpg" alt="hosting" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
        </Layout>
        </>
    )
}
export default DataCenter;